__webpack_require__.p = "/local/templates/main/assets/";